import { useEffect, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { http } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

// Lote 156 — página do link de convite (/convite/:token). Pública para quem tem o link: mostra o essencial;
// aceitar exige estar logado com o MESMO e-mail do convite.
export default function ConviteEscritorio() {
  const { token } = useParams();
  const nav = useNavigate();
  const auth = useAuth() || {};
  const user = auth?.user || null;
  const [c, setC] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { http.get(`/escritorio/convites/${token}`).then((r) => setC(r.data)).catch(() => setC({ valido: false, motivo: "Não consegui abrir o convite." })); }, [token]);
  const aceitar = async () => {
    setBusy(true);
    try { await http.post(`/escritorio/convites/${token}/aceitar`); toast.success("Você entrou no escritório"); if (auth?.checkAuth) { try { await auth.checkAuth(); } catch { /* ok */ } } nav("/escritorio"); }
    catch (e) { toast.error(e?.response?.data?.detail || "Não foi possível aceitar"); } finally { setBusy(false); }
  };
  return (
    <div className="min-h-screen bg-stone-50 flex items-center justify-center p-4">
      <div className="w-full max-w-md rounded-xl border border-stone-200 bg-white p-6" data-testid="convite-pagina">
        <div className="text-[11px] font-bold tracking-[0.28em] uppercase text-gold-600 mb-2">IApauta</div>
        {!c ? <p className="text-sm text-stone-500">Abrindo convite…</p> : !c.valido ? (
          <><h1 className="font-display text-2xl font-bold text-stone-900 mb-2">Convite indisponível</h1><p className="text-sm text-stone-600" data-testid="convite-motivo">{c.motivo}</p></>
        ) : (
          <>
            <h1 className="font-display text-2xl font-bold text-stone-900 mb-2" data-testid="convite-titulo">Convite para {c.escritorio}</h1>
            <p className="text-sm text-stone-600 mb-4">Você foi convidado como <b>{c.papel_rotulo}</b>, com o e-mail <b>{c.email}</b>.</p>
            {user ? (
              <Button data-testid="convite-aceitar" onClick={aceitar} disabled={busy} className="bg-stone-900 text-white hover:bg-stone-800">Aceitar convite</Button>
            ) : (
              <p className="text-sm text-stone-600" data-testid="convite-entrar">Entre ou crie sua conta com <b>{c.email}</b> e depois abra este link de novo. <Link to="/login" className="underline font-semibold">Ir para o login</Link></p>
            )}
          </>
        )}
      </div>
    </div>
  );
}
